export const getActionFlags = (action = {}) => {
  const { actionType } = action;

  const isReset = actionType === "RESET";
  const isResetKeyword = isReset || actionType === "RESET_KEYWORD";

  return {
    actionType,
    isReset,
    isResetKeyword,
  };
};
